import { render, staticRenderFns } from "./mec.vue?vue&type=template&id=10956612&scoped=true"
import script from "./mec.vue?vue&type=script&lang=js"
export * from "./mec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10956612",
  null
  
)

export default component.exports